import { createFromBaseTheme } from "@/style/baseTheme";
import { createTheme, ThemeOptions } from "@mui/material";

import logo from '/images/logo.png'
import logoBar from '/images/logoBar.png'

const customConstants: ThemeOptions = {
  palette: {
    primary: {
      main: "#60b22e",
    },
    secondary: {
      main: "#cfd700",
    }
  },
  custom: {
    constants: {
      logoImage: logo,
      logoBarImage: logoBar,
    }
  }
};

const baseCustomizedTheme = createFromBaseTheme(customConstants);

const customizations: ThemeOptions = {}

const newTheme = createTheme(baseCustomizedTheme, customizations);

export default newTheme;
